module.exports = __webpack_public_path__ + "static/media/youtube.71c35226.svg";